module.exports = __webpack_public_path__ + "img/smiling_imp.67cb4cb4.png";